import React, { useEffect, useMemo, useState } from 'react'
import '../styles/Process.css'
import { useTranslation } from '../context/LanguageContext.jsx'

const Process = () => {
  const { dict } = useTranslation()
  const [visible, setVisible] = useState(false)

  const steps = useMemo(
    () =>
      dict.process.steps.map((step, index) => ({
        ...step,
        number: String(index + 1).padStart(2, '0'),
      })),
    [dict.process.steps]
  )

  useEffect(() => {
    const el = document.querySelector('.process-steps')
    if (!el) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        setVisible(true)
        observer.disconnect()
      },
      { threshold: 0.2 }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [steps.length])

  return (
    <section id="process" className="process">
      <div className="process-inner">
        <header className="process-header">
          <h2>{dict.process.title}</h2>
          <p className="process-intro">{dict.process.intro}</p>
        </header>

        <ol className={`process-steps ${visible ? 'is-visible' : ''}`}>
          {steps.map((step, index) => (
            <li
              key={step.title}
              className="process-step"
              style={{ '--step-i': index }}
            >
              <span className="step-number" aria-hidden="true">
                {step.number}
              </span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default Process
